import { InjectedEntityClass } from './InjectedEntityClass';
import { PackageShelf } from '../../../packages/PackageShelf';
export class RuntimeInjected {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    entityClass = new InjectedEntityClass();
    packageShelf = new PackageShelf();
}
